// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__yJ1gd","colorize":"footer_colorize__WbGRe"};